import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import reportWebVitals from './reportWebVitals';
import MasterPage from './containers/MasterPage';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import Businesses from './containers/Businesses';
import Zones from './containers/Zones';
import { SERVICE_PREFIX } from './config-front';
import BusinessTypes from './containers/BusinessTypes';
import { URLS } from './config-front';
import Contactanos from './containers/Contactanos';

let routes = [
  {
    path: "/",
    element: <Zones />,
    loader: async ({ request, params }) => {
      return fetch(
        `${SERVICE_PREFIX}/zone`,
        { signal: request.signal }
      );
    }
  },
  {
    path: "/contactanos",
    element: <Contactanos />
  }
];

for (const url of URLS) {
  routes.push({
    path: url.path,
    element: <Navigate to={url.navigateTo} replace={true} />
  });
}

routes = routes.concat([
  // BusinessTypes
  {
    path: "/:department/:city/:neighborhood",
    element: <BusinessTypes />,
    loader: async ({ request, params }) => {
      return fetch(
        `${SERVICE_PREFIX}/business-types?department=${params.department}&city=${params.city}&neighborhood=${params.neighborhood}`,
        { signal: request.signal }
      );
    }
  },
  {
    path: "/:department/:city",
    element: <BusinessTypes />,
    loader: async ({ request, params }) => {
      return fetch(
        `${SERVICE_PREFIX}/business-types?department=${params.department}&city=${params.city}`,
        { signal: request.signal }
      );
    }
  },
  // Businesses
  {
    path: "/:department/:city/:neighborhood/:businessType",
    element: <Businesses />,
    loader: async ({ request, params }) => {
      return fetch(
        `${SERVICE_PREFIX}/businesses?department=${params.department}&city=${params.city}&neighborhood=${params.neighborhood}&businessType=${params.businessType}`,
        { signal: request.signal }
      );
    }
  },
  {
    path: "/:department/:city/:businessType",
    element: <Businesses />,
    loader: async ({ request, params }) => {
      return fetch(
        `${SERVICE_PREFIX}/businesses?department=${params.department}&city=${params.city}&businessType=${params.businessType}`,
        { signal: request.signal }
      );
    }
  }
]);

const router = createBrowserRouter([
  {
    path: "/",
    element: <MasterPage />,
    children: routes,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
